import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M9 12l2 2l4 -4","key":"svg-1"}]]

const IconSquareCheck = createReactComponent('outline', 'square-check', 'SquareCheck', __iconNode);

export default IconSquareCheck;